import utils from './util';

function payHandle({ appId, timeStamp, nonceStr, prepayId, paySign }, success, fail) {
  const _payload = {
    'appId': appId, // 公众号ID，由商户传入
    'timeStamp': timeStamp, // 时间戳，自1970年以来的秒数
    'nonceStr': nonceStr, // 随机串
    'package': `prepay_id=${prepayId}`,
    'signType': 'MD5', // 微信签名方式：
    'paySign': paySign // 微信签名
  };
  WeixinJSBridge.invoke('getBrandWCPayRequest', _payload,
    function(res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        success && success(res);
      } else {
        fail && fail(res);
      }
    });
}

export default {
  // params: payload 支付返回的参数，[,success, fail]
  wxPay(payload, ...args) {
    const _fn = async() => {
      await payHandle(payload, ...args);
    };
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', _fn, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', _fn);
        document.attachEvent('onWeixinJSBridgeReady', _fn);
      }
    } else {
      _fn();
    }
  },
  mpPay(payload, orderNo, type) {
    if (payload.appId) {
      delete payload.appId;
    }
    // payload.callbackUrl = `${window.location.href}&orderNo=${orderNo}&isCallBack=1`
    payload.callbackUrl = generateRedirctUrl({ orderNo, encode: false });

    for (const payloadKey in payload) {
      payload[payloadKey] = encodeURIComponent(payload[payloadKey]);
    }
    const url = utils.fillUrlWithParams('/pages/nativePay/index', payload);

    if (type === 'ticket') {
      wx.miniProgram.redirectTo({ url });
    } else {
      wx.miniProgram.navigateTo({ url });
    }
  },
  browserPay(url, orderNo, type) {
    // let redirectUrl = `${window.location.href}&isCallBack=1&payWay=wx`
    // if (redirectUrl.indexOf('orderNo') < 0) redirectUrl += `&orderNo=${orderNo}`
    // redirectUrl = encodeURIComponent(redirectUrl)

    const redirectUrl = generateRedirctUrl({ orderNo });
    location.replace(`${url}&redirect_url=${redirectUrl}`);
  }
};

/**
 * 生产重定向 url
 * @param {Object} param
 * @param {String} param.orderNo
 * @param {Boolean} param.encode - 是否转码
 * @returns
 */
function generateRedirctUrl({ orderNo, encode = true }) {
  const origin = window.location.origin;
  const path = window.location.pathname || '';
  // hash模式的路由， 例： #/phoneChargeDetail?orderNo=O1471768009176735744
  const hash = window.location.hash;

  const [routerHash, queryString] = hash.split('?');
  const queries = {
    isCallBack: '1'
  };

  if (queryString) {
    const searchParams = new URLSearchParams(queryString);
    for (const [key, value] of searchParams) {
      queries[key] = value;
    }
  }
  if (orderNo) {
    queries.orderNo = orderNo;
  }

  // 例： https://sitzengzhi.cias.cn/h5/#/phoneChargeDetail
  let redirectUrl = `${origin}${path}${routerHash}`;

  // 重新拼接 search
  const resSearchParams = new URLSearchParams('');
  Object
  .entries(queries)
  .forEach(([key, value]) => {
    resSearchParams.append(key, value);
  });

  const search = resSearchParams.toString();
  if (search) {
    redirectUrl += `?${search}`;
  }

  return encode ? encodeURIComponent(redirectUrl) : redirectUrl;
}
